import { Teleport as _Teleport, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "m-auto px-8 md:px-20 pb-8 pt-3" }
const _hoisted_2 = { class: "py-10 flex justify-between" }
const _hoisted_3 = { class: "bg-next-orange text-white p-3 mb-3 font-bold" }
const _hoisted_4 = { class: "pb-5 flex justify-between items-center" }
const _hoisted_5 = { class: "text-2xl" }
const _hoisted_6 = { class: "font-bold" }
const _hoisted_7 = { class: "font-bold" }
const _hoisted_8 = { class: "flex items-center" }
const _hoisted_9 = { class: "flex flex-col lg:col-span-2 w-96" }
const _hoisted_10 = { class: "m-auto" }
const _hoisted_11 = { class: "grid grid-cols-12 gap-3 mb-5" }
const _hoisted_12 = { class: "col-span-2 col-start-11 flex justify-end items-start" }
const _hoisted_13 = { class: "overflow-x-scroll" }
const _hoisted_14 = { class: "border-b-next-atp border-b-2 text-next-atp mb-3 sticky left-0" }
const _hoisted_15 = { class: "font-bold" }
const _hoisted_16 = { class: "flex gap-3 mb-3 sticky left-0" }
const _hoisted_17 = { class: "rotate-x-180 overflow-x-scroll mb-5 pb-3" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Alert = _resolveComponent("Alert")!
  const _component_Breadcrumbs = _resolveComponent("Breadcrumbs")!
  const _component_VueMultiselect = _resolveComponent("VueMultiselect")!
  const _component_Field = _resolveComponent("Field")!
  const _component_CardDivisorioGrigio = _resolveComponent("CardDivisorioGrigio")!
  const _component_NextButton = _resolveComponent("NextButton")!
  const _component_OffertaTable = _resolveComponent("OffertaTable")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_openBlock(), _createBlock(_Teleport, { to: "#modal" })),
    _createElementVNode("div", _hoisted_1, [
      (_ctx.error_message)
        ? (_openBlock(), _createBlock(_component_Alert, {
            key: 0,
            dismissable: true,
            onClose: _cache[0] || (_cache[0] = ($event: any) => (_ctx.error_message = '')),
            class: "bg-next-orange drop-shadow-lg w-96 fixed top-5 right-5 z-50"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.error_message), 1)
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_Breadcrumbs, { paths: _ctx.getBreadcrumbsPath }, null, 8, ["paths"])
      ]),
      _withDirectives(_createElementVNode("div", _hoisted_3, " I record non sono nella medesima valuta di vendita. Impossibile creare l'ordine di vendita. ", 512), [
        [_vShow, !_ctx.StessaValutaVendita]
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("h1", _hoisted_5, [
          _cache[2] || (_cache[2] = _createTextVNode(" Sottoprogetto: ")),
          _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.sottoprogetto?.titolo), 1),
          _cache[3] || (_cache[3] = _createTextVNode(" - Cliente: ")),
          _createElementVNode("span", _hoisted_7, _toDisplayString(_ctx.cliente.denominazione), 1)
        ]),
        _createElementVNode("div", _hoisted_8, [
          _cache[5] || (_cache[5] = _createElementVNode("h1", { class: "text-2xl mr-1" }, " Destinatario: ", -1)),
          _createElementVNode("div", _hoisted_9, [
            _createVNode(_component_Field, {
              "label-visible": false,
              required: !_ctx.destinatarioAutocomplete?.selection,
              placeholder: "Cliente"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_VueMultiselect, {
                  onSearchChange: _ctx.destinatarioAutocomplete.search,
                  loading: _ctx.destinatarioAutocomplete.isLoading,
                  options: _ctx.destinatarioAutocomplete.options,
                  modelValue: _ctx.destinatarioAutocomplete.selection,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.destinatarioAutocomplete.selection) = $event)),
                  "track-by": "id",
                  label: "denominazione",
                  class: "next-vue-multiselect-single",
                  placeholder: "Cliente",
                  deselectLabel: "Deseleziona",
                  selectedLabel: "Selezionato",
                  selectLabel: "Seleziona"
                }, {
                  noResult: _withCtx(() => _cache[4] || (_cache[4] = [
                    _createTextVNode("Nessun elemento trovato.")
                  ])),
                  singleLabel: _withCtx(({option}) => [
                    _createTextVNode(_toDisplayString(`${option.denominazione} - ${option.ragione_sociale}`), 1)
                  ]),
                  option: _withCtx(({option}) => [
                    _createTextVNode(_toDisplayString(`${option.denominazione} - ${option.ragione_sociale}`), 1)
                  ]),
                  _: 1
                }, 8, ["onSearchChange", "loading", "options", "modelValue"])
              ]),
              _: 1
            }, 8, ["required"])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_10, [
        _createElementVNode("div", _hoisted_11, [
          _createVNode(_component_CardDivisorioGrigio, { class: "col-span-2" }, {
            top: _withCtx(() => _cache[6] || (_cache[6] = [
              _createElementVNode("div", { class: "text-sm" }, [
                _createElementVNode("b", null, "Totale costi")
              ], -1)
            ])),
            bottom: _withCtx(() => [
              _createElementVNode("div", null, _toDisplayString(_ctx.Totalizzatori.totale_costi?.toCurrencyString()) + " € ", 1)
            ]),
            _: 1
          }),
          _createVNode(_component_CardDivisorioGrigio, { class: "col-span-2" }, {
            top: _withCtx(() => _cache[7] || (_cache[7] = [
              _createElementVNode("div", { class: "text-sm" }, [
                _createElementVNode("b", null, "Totale ordinato")
              ], -1)
            ])),
            bottom: _withCtx(() => [
              _createElementVNode("div", null, _toDisplayString(_ctx.Totalizzatori.totale_ordinato?.toCurrencyString()) + " € ", 1)
            ]),
            _: 1
          }),
          _createElementVNode("div", _hoisted_12, [
            _createVNode(_component_NextButton, {
              class: "px-10 py-3",
              onClick: _ctx.creaODV
            }, {
              default: _withCtx(() => _cache[8] || (_cache[8] = [
                _createTextVNode("Crea ODV")
              ])),
              _: 1
            }, 8, ["onClick"])
          ])
        ]),
        _createElementVNode("div", _hoisted_13, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.records, (i, k) => {
            return (_openBlock(), _createElementBlock(_Fragment, { key: k }, [
              _createElementVNode("div", _hoisted_14, [
                _createElementVNode("p", _hoisted_15, [
                  _cache[9] || (_cache[9] = _createTextVNode("Aliquota: ")),
                  _createElementVNode("span", null, _toDisplayString(k in _ctx.AliquoteVendita ? _ctx.AliquoteVendita[k]?.descrizione : 'Sconosciuta'), 1)
                ])
              ]),
              _createElementVNode("div", _hoisted_16, [
                _createElementVNode("p", null, [
                  _cache[10] || (_cache[10] = _createTextVNode("Totale ordinato: ")),
                  _createElementVNode("span", null, _toDisplayString(k in _ctx.TotalizzatoriIva ? _ctx.TotalizzatoriIva[k]?.totale_ordinato?.toCurrencyString() : 'Sconosciuta') + " €", 1)
                ]),
                _createElementVNode("p", null, [
                  _cache[11] || (_cache[11] = _createTextVNode("Totale ricavi: ")),
                  _createElementVNode("span", null, _toDisplayString(k in _ctx.TotalizzatoriIva ? _ctx.TotalizzatoriIva[k]?.totale_ricavi?.toCurrencyString() : 'Sconosciuta') + " €", 1)
                ])
              ]),
              _createElementVNode("div", _hoisted_17, [
                _createVNode(_component_OffertaTable, {
                  class: "rotate-0 overflow-hidden mb-3",
                  actionClass: "relative",
                  ordered_records: i,
                  onOrderUpdate: _ctx.performOrder
                }, null, 8, ["ordered_records", "onOrderUpdate"])
              ])
            ], 64))
          }), 128))
        ])
      ])
    ])
  ], 64))
}